import { Route, Routes } from "react-router-dom";
import "./App.css";
import HomePage from "./HomePage.jsx";
import OPCWPage from "./OPCWPage.jsx";

function App() {
  return <div className="site-shell">
  
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/8f3c2a71-6d94-4b18-a5e7-92c0f14d638b" element={<OPCWPage title="About the OPCW" eyebrow="The organisation" text="The OPCW works for a world permanently free of chemical weapons. This portal brings essential information about scheduled chemicals into one clear, accessible place." />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
  
  </div>;
}

export default App;